export default function PHP_krsort() {
  return (
    <div>
      <h1>PHP_krsort</h1>
    </div>
  );
}
